<template>
    <nav id="footer">
			<div class="">
				<div class="info-block container">
					<p><a href="/Privacy-policy"> Privacy Policy</a> |</p>
					<p><a href="/disclaimer">Disclaimer</a> | </p>
					<p><a href="/sitemap">Sitemap</a> |</p>
					<div class="pull-right fnav">
						<ul class="footer-social">
							<li><a href="https://www.facebook.com/compuinfo2016" target="_blank"><i class="fa fa-facebook"></i></a></li>
							<li><a href="https://twitter.com/compuinfo2016" target="_blank"><i class="fa fa-twitter"></i></a></li>
                            <li><a href="https://www.linkedin.com/company/compu-info" target="_blank"><i class="fa fa-linkedin"></i></a></li>
						</ul>
					</div>				
				</div>
				<div class="col-md-12">
					<hr>
				</div>
				<div class="fnav container">
					<p class="pull-left">© {{getCurrentYear()}} Compu-Info</p>
				</div>

			</div>
		</nav>
</template>

<script>
export default {
	methods:{
		getCurrentYear(){
			return new Date().getFullYear()
		}
	}
}
</script>